import { StorageKeys } from './../../config/storage.keys';
import { Injectable } from "@angular/core";
import { MainPage, WelcomePage } from "../../pages/pages";
import { App } from "ionic-angular";
import { NavController } from "ionic-angular/index";
import { AuthService, ShareData, DataStorage } from "../providers";

@Injectable()
export class User {
  private navCtrl: NavController;

  static get parameters() {
    return [[App], [AuthService],[ShareData], [DataStorage]];
  }
  countDataResponse: any;
  constructor(
    private app: App,
    private auth: AuthService,
    public shareData: ShareData,
    public dataStorage: DataStorage
  ) {
    this.navCtrl = this.app.getRootNavs()[0];
  }


  usernameCheck(username: string){
    if(username.length === 0)
    return this.app.getRootNavs()[0].push("UsernamePage")
  }

  getData() {
    const data = this.dataStorage.get(StorageKeys.USER_AUTH);
    const userDetails = data;

    if (data) {
      return userDetails.userData;
    } else {
      return false;
    }
  }

  storeProfileData(data) {
    return this.dataStorage.store(StorageKeys.USER_PROFILE, data);
  }

  getProfileData() {
    const data = this.dataStorage.get(StorageKeys.USER_AUTH);
    const profileDetails = data;

    if (data) {
      return profileDetails.userData;
    } else {
      return false;
    }
  }

  getProfileUsername(profileUsername, username){
    if(profileUsername){
      return profileUsername;
    }
    else{
     return username;
    }
  }

  backToWelcome() {
   // this.navCtrl.setRoot(WelcomePage);
    //this.navCtrl.popToRoot;
     const root = this.app.getRootNav();
     root.popToRoot();
   //  this.app.getRootNav().setRoot(WelcomePage);
     this.app.getRootNavs()[0].push(WelcomePage)
  }

  logOut() {
    this.dataStorage.remove(StorageKeys.USER_AUTH);
    this.backToWelcome();
    return true;
  }

  sessionIn() {
    if (this.getData()) {
      this.navCtrl.setRoot(MainPage);
      this.navCtrl.popToRoot;
    }
  }

  sessionOut() {
    if (!this.getData()) {
      this.navCtrl.setRoot(WelcomePage);
      this.navCtrl.popToRoot;
    }
  }

  countData(uid, token){
    this.conversationsCount(uid, token);
    this.notificationsCount(uid, token);
  }

  conversationsCount(uid, token) {
    let postData = {};  
    this.auth.authPostData(uid, token, postData, "conversationsNewCount").then(
      result => {
       if(result){
        this.countDataResponse = result;
        if(this.countDataResponse && this.countDataResponse.countData.count){
          this.shareData.changeConversationCount(this.countDataResponse.countData.count);
        }
      }
      },
      err => {}
    );
  }

  notificationsCount(uid, token) {
    let postData = {};    
    this.auth.authPostData(uid, token, postData, "notificationsNewCount").then(
      result => {
        if(result){
          this.countDataResponse = result;
          if(this.countDataResponse && this.countDataResponse.countData.count){
            this.shareData.changeNotificationCount(this.countDataResponse.countData.count);
          }
          
        }
    
      },
      err => {}
    );
  }


}



// WEBPACK FOOTER //
// ./src/providers/user/user.ts